import React from "react";
import { Select, Form } from "antd";
import { Controller } from "react-hook-form";
import { getError } from "../../../utils/form";

const itemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    lg: { span: 10 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    lg: { span: 14 },
  },
};

const ControlledSelect = ({
  control,
  errors,
  name,
  label,
  required,
  options,
  multiple = false,
  customChange,
  loading = false,
}) => {
  const error = getError({ errors, name });
  const handleChange = (val, onChange) => {
    onChange(val);
    if (customChange) {
      customChange(val);
    }
  };
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          label={label}
          {...itemLayout}
          required={required}
          labelAlign="left"
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          <Select
            mode={multiple ? "multiple" : null}
            {...field}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(val) => handleChange(val, field.onChange)}
            loading={loading}
            placeholder={loading ? "Loading..." : undefined}
            /*  onFocus={() => {
              let el = document.getElementsByName(name);
              el = el[0].children[0].children[0].children[0];
              el.setAttribute("autocomplete", "autocomplete_off");
              el.setAttribute("id", `${label}_`);
            }} */
            style={{ width: "100%" }}
          >
            {options}
          </Select>
        </Form.Item>
      )}
    />
  );
};

export default ControlledSelect;
